import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { AccountService } from 'app/core';
import { UserAssociation } from 'app/core/models';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { ContactsService } from 'app/modules/contacts/contacts.service';
import { Contact, Category } from 'app/modules/contacts/contacts.types';
import { Offer } from 'app/modules/projects/details/offers/offers.types';
import { DispositionGroup } from '../../@shared/types/dispositions.types';
import { Appointment, Comment } from 'app/modules/projects/projects.types';
import { DispositionsService } from '../../@shared/services/dispositions.service';
import { OffersService } from 'app/modules/projects/details/offers/offers.service';
import { Store } from '@ngxs/store';

@Injectable({
  providedIn: 'root',
})
export class AppointmentsResolver {
  constructor(
    private _projectsService: ProjectsService,
    private _accountService: AccountService,
  ) {
    this._accountService.currentAccount.subscribe((accountData) => {
      this._projectsService.accountId = accountData.id;
    });
  }

  resolve(): Observable<Appointment[]> {
    return this._projectsService.getAppointments();
  }
}

@Injectable({
  providedIn: 'root',
})
export class ContactsResolver {
  constructor(
    private _projectsService: ProjectsService,
    private _contactsService: ContactsService,
    private _accountService: AccountService,
  ) {
    this._accountService.currentAccount.subscribe((accountData) => {
      this._projectsService.accountId = accountData.id;
      this._contactsService.accountId = accountData.id;
    });
  }

  resolve(): Observable<Contact[]> {
    return this._projectsService.getContacts();
  }
}

@Injectable({
  providedIn: 'root',
})
export class ContactsCategoriesResolver {
  constructor(private _accountService: AccountService) {}

  resolve(): Observable<Category[]> {
    return this._accountService.getCategories();
  }
}

@Injectable({
  providedIn: 'root',
})
export class CommentsResolver {
  constructor(
    private _projectsService: ProjectsService,
    private _accountService: AccountService,
  ) {
    this._accountService.currentAccount.subscribe((accountData) => {
      this._projectsService.accountId = accountData.id;
    });
  }

  resolve(): Observable<Comment[]> {
    return this._projectsService.getComments();
  }
}

@Injectable({
  providedIn: 'root',
})
export class DispositionGroupsResolver {
  constructor(
    private _dispositionsService: DispositionsService,
    private _projectsService: ProjectsService,
    private _accountService: AccountService,
    private readonly store: Store,
  ) {
    this._accountService.currentAccount.subscribe((accountData) => {
      this._dispositionsService.accountId = accountData.id;
      this._projectsService.project$.subscribe((project) => {
        this._dispositionsService.projectId = project.id;
      });
    });
  }

  resolve(): Observable<{ disposition_groups: DispositionGroup[] }> {
    return this._dispositionsService.getDispositionGroups();
  }
}

@Injectable({
  providedIn: 'root',
})
export class OffersResolver {
  constructor(
    private _offersService: OffersService,
    private _projectsService: ProjectsService,
    private _accountService: AccountService,
  ) {
    this._accountService.currentAccount.subscribe(() => {
      this._projectsService.project$.subscribe((project) => {
        this._offersService.projectId = project.id;
      });
    });
  }

  resolve(): Observable<Offer[]> {
    return this._offersService.getOffers();
  }
}

@Injectable({
  providedIn: 'root',
})
export class UsersResolver {
  constructor(
    private _projectsService: ProjectsService,
    private _accountService: AccountService,
  ) {
    this._accountService.currentAccount.subscribe((accountData) => {
      this._projectsService.accountId = accountData.id;
    });
  }

  resolve(): Observable<UserAssociation[]> {
    return this._projectsService.getUserAssociations();
  }
}
